import React, {FC} from 'react';

import {HandlerOf} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {
  DropdownItem,
  DropdownItemProps,
} from '../../../../../libs/shared/ui/src/components/dropdowns/dropdownItem';
import {DropdownItemContent} from '../../../../../libs/shared/ui/src/components/dropdowns/dropdownItemContent';
import {InboxModel} from '../../../../models/api/inboxModel';
import {
  CellsRefinementOptionsEnum,
  RefinementOptionModel,
} from '../../../../models/api/refinementOptionModel';
import {DropdownItemInboxDot} from '../../../common/dropdowns/dropdownItemInboxDot';

/*
 * Props.
 */

interface CellsRefinementOptionsSearchInboxesDropdownRowProps extends DropdownItemProps {
  selectedRefinement: RefinementOptionModel | undefined;
  onSelectInbox: HandlerOf<InboxModel>;
  inbox: InboxModel;
  isNotInteractive?: boolean;
}

/*
 * Component.
 */

export const CellsRefinementOptionsSearchInboxesDropdownRow: FC<
  CellsRefinementOptionsSearchInboxesDropdownRowProps
> = (props) => {
  const {inbox, isNotInteractive, onSelectInbox, selectedRefinement} = props;

  const isChecked =
    selectedRefinement !== undefined &&
    selectedRefinement.type === CellsRefinementOptionsEnum.INBOX &&
    selectedRefinement.id === inbox.id;

  return (
    <DropdownItem
      key={inbox.id}
      onSelect={() => onSelectInbox(inbox)}
      isNotInteractive={isNotInteractive}
      isChecked={isChecked}
      {...props}
    >
      <DropdownItemInboxDot inbox={inbox} />
      <DropdownItemContent isChecked={isChecked}>{inbox.name}</DropdownItemContent>
    </DropdownItem>
  );
};
